export const categoryRoutes = [
    "/",
    "grounded",
    "passed",
    "purchased",
    "conditionreport"
]

export const VehicleData = [
    "Brand",
    "ExtColor",
    "Model",
    "ModelNumber",
    "ModelYear",
    "VIN"
]

export const PickupLocationData = [
    "AddressLine1",
    "AddressLine2",
    "City",
    "LocationContact",
    "LocationName",
    "LocationNotes",
    "Phone",
    "State",
    "ZIP"
]

export const KeysData = [
    "KeyType",
    "NoOfKeysReturned"
]

export const settingDropDownResponse = [
    "Y",
    "N"
]

export const settingDropDownDataLabel = [
    "Skip Preview Buy Bid for Dealer Groundings:",
    "Allow Time for Bid Price Change:"
]

export const settingTimeStampLabel = [
    "Preview Buy Bid Start Time:",
    "Preview Buy Bid End Time:"
]

export const settingUserInputLabel = [
    "AutoVIN Inspection Lead Time:",
    "VINTrack Inspection Lead Time:",
    "VINTrack post Inspection Validity:"
]

export const dealerproviderDropDownDataLabel = [
    "Dealer",
    "Inspection Provider",
    "Time Zone",
    "Default Auction",
    "Default Transportation Provider"  
]

export const dealerproviderDropDownResponse = [
    "Dealer",
    "Provider"
]

export const ManualPricingTableHeading = [
    {
        label: "VIN",
        id: "vin"
    },
    {
        label: "Year",
        id: "modelYear"
    },
    {
        label: "Make",
        id: "make"
    },
    {
        label: "Model/Trim",
        id: "model"
    },
    {
        label: "Grounding Region",
        id: "groundingRegion"
    },
    {
        label: "Inspection Date (CT)",
        id: "inspectionDate"
    },
    {
        label: "Inspection Status",
        id: "inspectionStatus"
    },
    {
        label: "Auction Code",
        id: "auctionCode"
    },
];

export const RRMApprovalTableHeading = [
    {
        label: "VIN",
        id: "vin"
    },
    {
        label: "Year",
        id: "modelYear"
    },
    {
        label: "Make",
        id: "make"
    },
    {
        label: "Model/Trim",
        id: "model"
    },
    {
        label: "Auction",
        id: "auction"
    },
    {
        label: "MMR",
        id: "mmr"
    },
    {
        label: "MBP",
        id: "mbp"
    },
    {
        label: "%",
        id: "pricedIffpct"
    },
    {
        label: "Priced Date (CT)",
        id: "pricedDate"
    },
    {
        label: "Priced By",
        id: "pricedBy"
    },
    {
        label: "Approve",
        id: "approve"
    },
];

export const MilleageDiscTableHeading = [
    {
        label: "VIN",
        id: "vin"
    },
    {
        label: "Year",
        id: "modelyear"
    },
    {
        label: "Make",
        id: "make"
    },
    {
        label: "Model/Trim",
        id: "model"
    },
    {
        label: "Region",
        id: "region"
    },
    {
        label: "Grounding Mileage",
        id: "adjMileage"
    },
    {
        label: "Inspection Mileage",
        id: "inspectionmileage"
    },
    {
        label: "Difference",
        id: "mileagediff"
    }
];
export const VehicleStatusHeading=[
    {
        label: "Transaction",
        id: "transactiontype"
    },
    {
        label: "Status",
        id: "status"
    },
    {
        label: "User/ID",
        id: "userid"
    },
    {
        label: "Date/Time(CT)",
        id: "transactiondate"
    }
];

export const ArbitrationTableHeading = [
    {
        label: "Arbitration ID",
        id: "arbitration_id"
    },
    {
        label: "VIN",
        id: "vin"
    },
    {
        label: "Dealer",
        id: "dealer"
    },
    {
        label: "Year",
        id: "model_year"
    },
    {
        label: "Make",
        id: "brand"
    },
    {
        label: "Model/Trim",
        id: "modeltrim"
    },
    {
        label: "Color",
        id: "ext_color"
    },
    {
        label: "Current Status",
        id: "status"
    },
    {
        label: "Arbitration Date",
        id: "arbitration_date"
    }
];

export const BusinessAdminExtractTableHeading = [
    {
        label: "Extract Name",
        id: "arbitration_id"
    }
];

export const AdminSettingTableHeading = [
    {
        label: "Name",
        id: "settingName"
    },
    {
        label: "Value",
        id: "settingValue"
    }
];

export const EventSystemAdminTableHeading = [
    {
        label: "ID",
        id: "event_id",
        textField: false
    },
    {
        label: "Name",
        id: "event_name",
        textField: false
    },
    {
        label: "Predecessors",
        id: "event_predecesssors",
        textField: false
    },
    {
        label: "Created Date",
        id: "event_created_date",
        textField: false
    },
    {
        label: "Executed Date",
        id: "event_executed_date",
        textField: false
    },
    {
        label: "Scheduled Date",
        id: "event_scheduled_date",
        textField: true
    },
    {
        label: "Scheduler Name",
        id: "event_scheduler_name",
        textField: true
    },
    {
        label: "Status",
        id: "event_status",
        textField: true
    }
];